import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.494 4.38v2.622a.75.75 0 01-1.498 0V4.38c0-.336-.04-.374-.375-.374h-2.623a.75.75 0 110-1.5h2.623a1.738 1.738 0 011.873 1.874zM7.002 2.505H4.38a1.739 1.739 0 00-1.873 1.873v2.623a.75.75 0 101.499 0V4.38c0-.336.039-.374.374-.374h2.623a.75.75 0 000-1.5zm0 13.49H4.38c-.335 0-.374-.039-.374-.375v-2.623a.75.75 0 10-1.5 0v2.623a1.738 1.738 0 001.874 1.873h2.623a.75.75 0 000-1.498zm9.743-3.748a.75.75 0 00-.75.75v2.623c0 .336-.038.375-.374.375h-2.623a.75.75 0 000 1.498h2.623a1.737 1.737 0 001.873-1.873v-2.623a.75.75 0 00-.749-.75z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
